import { FEATURE_NAME } from "@/components/LicenseGuard/LicenseGuard.constant";
import { useHasLicenseAccess } from "@/components/LicenseGuard/useHasLicenseAccess";

import { useLocation } from "react-router";

export function useAiLabelRule() {
  const location = useLocation();

  const hasAiStandardAccess = useHasLicenseAccess({
    feature: FEATURE_NAME.AI_STANDARD_ACCESS,
  });

  const hasAiPath = ["/insights", "/evaluation"].some((path) =>
    location.pathname.includes(path)
  );
  const show = hasAiPath && hasAiStandardAccess;

  return { show };
}
